<section class="hello-text row custom-rounded custom-gradient px-2 mt-2">
  <header>
    <h1 class="greetings fs-4 fw-bold pt-2">Hello there!</h1>
  </header>
  <p class="sub-text">
    Unlock the power of customer feedback with our platform, providing key metrics and insights to track sentiment,
    loyalty, and satisfaction. Easily monitor scores, spot trends, and turn insights into actionable strategies that
    drive success and strengthen customer relationships.
  </p>
</section>

<section class="px-0 py-2 pb-0">
  <div class="row gx-2 gy-2">
    <!-- Card 1: My Total Projects -->
    <article class="col flex justify-content-center">
      <div class="card custom-rounded">
        <div class="card-body text-center">
          <header class="row">
            <div class="col-6">
              <h6 class="card-title text-start fw-bold my-total-projects">My Total Projects</h6>

              <h1 class="card-text text-start fw-bold lato mb-2">{{ totalProjects }}</h1>
            </div>
            <div class="col-6 d-flex justify-content-between align-items-start">
              <!-- Search Bar -->
              <div class="input-group custom-rounded search-group">
                <span class="input-group-text bg-transparent border-0" id="search-icon">
                  <img src="assets/images/search-icon.svg" alt="Search Icon" class="search-icon default-icon" />
                  <img src="assets/images/blue-search-icon.svg" alt="Search Icon" class="search-icon active-icon" />
                </span>
                <input type="text" class="form-control border-0 custom-rounded p-0 search-input"
                  placeholder="Search project" aria-label="Search project" aria-describedby="search-icon"
                  [(ngModel)]="searchQuery" />
                  <button class="clear-search" *ngIf="searchQuery != ''" (click)="clearSearch()">
                    <img src="assets/images/close.svg"/>
                </button>
              </div>
            </div>
          </header>
          <div class="custom-div d-flex align-items-center text-start px-3 py-2">
            <span [ngClass]="getClassNameBySorting('projectList')">Projects</span>
            <div>
              <img [src]="sortingOrder['projectList'] === 'asc' 
              ? 'assets/images/black-arrow-down.svg' 
              : 'assets/images/blue-down-arrow.svg'" class="arrow-icon" alt="Arrow icon" (click)="sortList('projectList','name')" />
            </div>
          </div>

          <!-- Scrollable List Wrapper -->
          <div [ngClass]="{ 'scrollable-list': filteredProjects().length > 30 }" [ngStyle]="{'margin-top': '5px'}">
            <ul class="list-group list-group-flush text-start">
              <!-- Show "No projects found" message when no matching projects are found -->
              <ul *ngIf="filteredProjects().length === 0 && searchQuery" class="text-center text-muted no-bullet pt-2">
                No projects found.
              </ul>
              <li class="py-2 d-flex align-items-center project-list" *ngFor="let brand of filteredProjects()">
                <a id="brandlistselection_{{brand._id}}" (click)="navigateTo(accountId, brand._id, brand)"
                  class="open-in-new-icon text-decoration-none project-link">
                  <img class="me-2 default-icon" src="assets/images/launch.svg" alt="Open project icon">
                  <img class="me-2 active-icon" src="assets/images/blue-link-icon.svg"
                    alt="Open project icon (active)" />
                    <span class="projectClickable">{{ brand.name }}</span>
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </article>
    <!-- Card 2: Recently Visited Projects -->
    <article class="col flex justify-content-center">
      <div class="card custom-rounded">
        <div class="card-body text-center">
          <header>
            <h6 class="card-title text-start fw-bold">Recently Visited Projects</h6>
          </header>
          <div class="custom-div d-flex align-items-center text-start px-3 py-2">
            <span [ngClass]="getClassNameBySorting('recentProjects')">Projects</span>
            <div>
              <img [src]="sortingOrder['recentProjects'] === 'asc' 
              ? 'assets/images/black-arrow-down.svg' 
              : 'assets/images/blue-down-arrow.svg'" class="arrow-icon" alt="Arrow icon"
                (click)="sortList('recentProjects', 'last_visited')" />
            </div>
          </div>
          <app-ltms-loader *ngIf="showLoader"></app-ltms-loader>
          <ul class="list-group list-group-flush text-start" *ngIf="!showLoader">
            <li class="py-2 d-flex align-items-center project-list" *ngFor="let list of recentVisitList">
              <a href="javascript:void(0)" (click)="navigateTo(list.account_id, list.project_id,  list)"
                class="open-in-new-icon text-decoration-none project-link">
                <img class="me-2 default-icon" src="assets/images/launch.svg" alt="Open project icon">
                <img class="me-2 active-icon" src="assets/images/blue-link-icon.svg"
                  alt="Open project icon (active)" />
                {{ list.name }}
              </a>
            </li>
          </ul>
          <div *ngIf="!recentVisitList?.length && !showLoader" class="no-recent-items">
            No recent items. Visit projects to see them here.
          </div>
        </div>
      </div>
    </article>
    <!-- Card 3: Quick Access -->
    <aside class="col flex justify-content-center">
      <div class="card custom-rounded">
        <div class="card-body text-center">
          <header>
            <h6 class="card-title text-start fw-bold">Quick Access</h6>
          </header>
          <nav>
            <!-- Loop through Quick Access Buttons -->
            <button *ngFor="let button of buttons" 
              class="btn quick_access-card {{ button.class }} my-1" (click)="jumpTo(accountId, button.action)">
              <div class="card-body text-center">
                <h6 class="text-start fw-bold">{{ button.title }}</h6>
                <div class="btn-content">
                  <p class="text-start" [innerHTML]="button.description">{{ button.description }}</p>
                  <div>
                    <img [src]="button.icon" alt="Button Icon" class="icon-size" />
                  </div>
                </div>
              </div>
            </button>
          </nav>
        </div>
      </div>
    </aside>
  </div>
</section>